import o from"@mui/material/IconButton";import{styled as t,alpha as e}from"@mui/material/styles";const m=t(o)((({theme:o})=>({"&:hover":{backgroundColor:e(o.palette.blue400.main,.24)}})));export{m as Button};
//# sourceMappingURL=styles.js.map
